import axios from "axios";
import { PUBLIC_PATH_PREFIXES } from "./publicPaths";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const cfg = err.config || {};
      const reqUrl = (cfg.url || "") + "";
      const isPublicApi = reqUrl.includes("/public/") || reqUrl.startsWith("/auth/me");
      const onPublicPage = typeof window !== "undefined"
        && PUBLIC_PATH_PREFIXES.some((p) => window.location.pathname.startsWith(p));
      // Never redirect when:
      //  - the caller passed skipAuthRedirect
      //  - the user is on a public page
      //  - the request itself is a public-API or auth-probe call
      if (!cfg.skipAuthRedirect && !onPublicPage && !isPublicApi) {
        // SC users don't have a password — bounce them to the mobile OTP screen
        // instead of the staff /login page. Same for the customer app.
        const onScRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/sc");
        const onAppRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/app")
          && !window.location.pathname.startsWith("/app/quote") && !window.location.pathname.startsWith("/app/survey");
        window.location.href = onScRoute ? "/sc/signup" : onAppRoute ? "/app/login" : "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
